import React from 'react';
import { Helmet } from 'react-helmet'; //TODO: Generate type definitions

import { GDPRBanner } from '@wkda/gdpr-banner-react'; //TODO: Generate type definitions

import { useModulesStore } from '../hooks/useModules';
import { ModalManager } from '../ModalManager';
import { useAppConfiguration, useCookieBannerQuery } from '../hooks/useDataHooks';
import { useGTM } from '../hooks/useGTM';
import { useTrackLandingCallback } from '../hooks/tracking/useMarketingTrackingService';

const DefaultGDPRBanner = _ref => {
  let {
    APIService,
    cookieService,
    isProd,
    content,
    closeHandler,
    gtmService
  } = _ref;
  const trackLanding = useTrackLandingCallback();
  const {
    isPartnerFunnel
  } = useAppConfiguration();
  return /*#__PURE__*/React.createElement(GDPRBanner, {
    APIService: APIService,
    cookieService: cookieService,
    isProd: isProd,
    content: content,
    closeHandler: closeHandler,
    onSubmit: () => {
      if (!isPartnerFunnel) {
        gtmService.update();
        trackLanding();
      }
    }
  });
};

function GDPRBannerContainer(_ref2) {
  let {
    customGDPRBanner: CustomGDPRBanner = DefaultGDPRBanner
  } = _ref2;
  const {
    gdprPreferencesModule
  } = useModulesStore();
  const {
    isPartnerFunnel
  } = useAppConfiguration();
  const {
    data: content,
    status
  } = useCookieBannerQuery();
  const [GTMScript, setGTMScript] = React.useState(null);
  const gtmService = useGTM({
    onStart: function (script) {
      if (!isPartnerFunnel) {
        setGTMScript(script);
      }
    }
  });
  return status === 'success' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalManager.Modal, {
    type: ModalManager.types.MANDATORY,
    id: "gdpr-banner"
  }, _ref3 => {
    let {
      closeHandler
    } = _ref3;
    return /*#__PURE__*/React.createElement(CustomGDPRBanner, {
      APIService: gdprPreferencesModule.APIService,
      cookieService: gdprPreferencesModule.cookieService,
      isProd: gdprPreferencesModule.isProd,
      content: content,
      closeHandler: closeHandler,
      gtmService: gtmService
    });
  }), /*#__PURE__*/React.createElement(Helmet, null, GTMScript ? /*#__PURE__*/React.createElement("script", null, GTMScript) : null)) : null;
}

export { GDPRBannerContainer as GDPRBanner };